var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"reviewsChart"}},[_c('apexchart',{ref:"chart",attrs:{"type":"bar","options":_vm.visitorBarChartConfig,"series":[{ data: _vm.visitorBarChartSeries || [] }]}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }